export class Indeterminate {
show: boolean;
constructor(init?: Partial<Indeterminate>) {
        Object.assign(this, init);
    }
}
